import { useEffect } from 'react';
export default function useOnClickOutside(refs, handler, flag = true) {
    useEffect(() => {
        const listener = (event) => {
            if (refs && refs.some(item => !item.current || item.current.contains(event.target))) {
                return;
            }
            handler(event);
        };
        if (flag) {
            document.addEventListener('mousedown', listener);
            document.addEventListener('touchstart', listener);
        }
        else {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        }
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [refs, handler, flag]);
}
//# sourceMappingURL=use-on-click-outside.js.map